const ActionTypes = {
    GET_CHUNK_URL_FAILURE: 'GET_CHUNK_URL_FAILURE',
    GET_CHUNK_URL_REQUEST: 'GET_CHUNK_URL_REQUEST',
    GET_CHUNK_URL_SUCCESS: 'GET_CHUNK_URL_SUCCESS',
    COMPLETE_MULTIPART_UPLOAD_FAILURE: 'COMPLETE_MULTIPART_UPLOAD_FAILURE',
    COMPLETE_MULTIPART_UPLOAD_REQUEST: 'COMPLETE_MULTIPART_UPLOAD_REQUEST',
    COMPLETE_MULTIPART_UPLOAD_SUCCESS: 'COMPLETE_MULTIPART_UPLOAD_SUCCESS',
    UPLOAD_FILE_COMPLETED: 'UPLOAD_FILE_COMPLETED',
    UPLOAD_FILE_ERROR: 'UPLOAD_FILE_ERROR',
    UPLOAD_FILE_START: 'UPLOAD_FILE_START',
} as const

export default ActionTypes
